import { Component } from "solid-js";
import { TournamentCivAbrr } from "../types/tournaments";
import { civs } from "../utils/civs";

export const CivIcon: Component<{ civ: TournamentCivAbrr; title?: string; class?: string }> = (props) => {
  return (
    <img
      src={civs[props.civ]?.flag ?? null}
      class={`w-10 h-6 rounded object-cover outline outline-1 outline-offset-1 ${props.class}`}
      style={{ "outline-color": civs[props.civ]?.color }}
      title={props.title}
      
    />
  );
};
